module.exports = __webpack_public_path__ + "bbc9b968f936baed7e7664b9c037aa80.woff2";